var map = {
	"./Black_Account_Icons-01.png": 664,
	"./Black_Account_Icons-02.png": 665,
	"./Black_Account_Icons-03.png": 666,
	"./Black_Account_Icons-04.png": 667,
	"./Black_Account_Icons-05.png": 668,
	"./Black_Account_Icons-06.png": 669,
	"./Black_Account_Icons-07.png": 670,
	"./Black_Account_Icons-08.png": 671,
	"./Black_Account_Icons-09.png": 672,
	"./Black_Account_Icons-10.png": 673,
	"./Black_Account_Icons-11.png": 674,
	"./Black_Account_Icons-12.png": 675,
	"./Black_Account_Icons-13.png": 676,
	"./Black_Account_Icons-14.png": 677,
	"./FilePresentOutlined.svg": 678,
	"./accuracyAccountsDemo_downloadMT4.jpg": 679,
	"./accuracyAccountsReal_downloadMT4.jpg": 680,
	"./alert@2x.svg": 681,
	"./apple-brands.svg": 682,
	"./arrow_up_from_box.svg": 683,
	"./bankWire.svg": 684,
	"./bdswissDemo_downloadMT4.png": 685,
	"./bdswissGlobalDemo_downloadMT4.png": 686,
	"./bdswissGlobalReal02_downloadMT4.png": 687,
	"./bdswissGlobalReal03_downloadMT4.png": 688,
	"./bdswissGlobalReal04_downloadMT4.png": 689,
	"./bdswissGlobalReal05_downloadMT4.png": 690,
	"./bdswissGlobalReal_downloadMT4.png": 691,
	"./bdswissGlobalReal_downloadMT5.png": 692,
	"./bdswissReal02_downloadMT4.png": 693,
	"./bdswissReal03_downloadMT4.png": 694,
	"./bdswissReal04_downloadMT4.png": 695,
	"./bdswissReal05_downloadMT4.png": 696,
	"./bdswissReal_downloadMT4.png": 697,
	"./bdswissReal_downloadMT5.png": 698,
	"./bdswissSCDemo_downloadMT4.png": 699,
	"./bdswissSCReal01_downloadMT4.png": 700,
	"./bdswissSCReal02_downloadMT4.png": 701,
	"./bdswissSCReal03_downloadMT4.png": 702,
	"./bdswissSCReal04_downloadMT4.png": 703,
	"./bdswissSCReal05_downloadMT4.png": 704,
	"./bdswiss_grey.png": 705,
	"./bdswiss_white.png": 706,
	"./bg-image-affiliate.png": 707,
	"./bitwallet-bdSwiss-dark.svg": 708,
	"./bitwallet-bdSwiss-light.svg": 709,
	"./bitwallet-swissMarkets-dark.svg": 710,
	"./bitwallet-swissMarkets-light.svg": 711,
	"./card.svg": 712,
	"./check_circle.png": 713,
	"./chf.png": 714,
	"./competitions.png": 715,
	"./complimentary@2x.svg": 716,
	"./control-radio-off.png": 717,
	"./control-radio-on.png": 718,
	"./crypto.svg": 719,
	"./cvv.svg": 720,
	"./deposit-card.svg": 721,
	"./diners.png": 722,
	"./dkk.png": 723,
	"./document-upload-failure-dark.png": 724,
	"./document-upload-failure-light.png": 725,
	"./document-upload-success-black.png": 726,
	"./document-upload-success-dark.png": 727,
	"./document-upload-success-light.png": 728,
	"./documents-empty-dark.png": 729,
	"./documents-empty-light.png": 730,
	"./downloadPdf-light.png": 731,
	"./downloadPdf.png": 732,
	"./dpWorldTourChampionship-dark.svg": 733,
	"./dpWorldTourChampionship-light.svg": 734,
	"./eWallet.svg": 735,
	"./eur.png": 736,
	"./exp-date.svg": 737,
	"./fees@2x.svg": 738,
	"./filterIcon.png": 739,
	"./gbp.png": 740,
	"./icon-add-account.svg": 440,
	"./icon-appstore@2x.png": 741,
	"./icon-arrow-right-dark.png": 742,
	"./icon-arrow-right-light.png": 743,
	"./icon-bank-wire.svg": 744,
	"./icon-checkbox.svg": 745,
	"./icon-close-dark.svg": 746,
	"./icon-close-light.svg": 747,
	"./icon-close.png": 748,
	"./icon-contact-callback@2x.png": 749,
	"./icon-contact-callback@2x.svg": 750,
	"./icon-contact-chat@2x.png": 441,
	"./icon-contact-chat@2x.svg": 442,
	"./icon-contact-email@2x.png": 751,
	"./icon-contact-email@2x.svg": 752,
	"./icon-contact-faqs@2x.png": 753,
	"./icon-contact-faqs@2x.svg": 754,
	"./icon-contact-oneOnOneSession@2x.png": 755,
	"./icon-contact-telegram@2x.png": 756,
	"./icon-contact-whatsapp@2x.png": 757,
	"./icon-crypto.svg": 758,
	"./icon-document.svg": 759,
	"./icon-facebook@2x.png": 760,
	"./icon-google-play@2x.png": 761,
	"./icon-notification.svg": 762,
	"./icon-profile-big.svg": 763,
	"./icon-profile.svg": 764,
	"./icon-spoa.svg": 765,
	"./icon-swapFree.svg": 766,
	"./icon-telegram@2x.png": 767,
	"./icon-twitter@2x.png": 768,
	"./icon_accounts_dashboard.svg": 769,
	"./icon_logout_dashboard.svg": 770,
	"./icon_notification_dashboard.svg": 771,
	"./icon_profilesettings_dashboard.svg": 772,
	"./icon_support_dashboard.svg": 773,
	"./icon_transaction_dashboard.svg": 774,
	"./jcb.png": 775,
	"./languages.png": 776,
	"./limit-failure-dark.png": 777,
	"./limit-failure-light.png": 778,
	"./logo-accuracy.png": 779,
	"./logo-bdstrading-white.svg": 780,
	"./logo-bdstrading.svg": 781,
	"./logo-bdswiss-white.svg": 782,
	"./logo-bdswiss.png": 783,
	"./logo-bdswiss.svg": 784,
	"./logo-equityflow-black.png": 785,
	"./logo-equityflow-white.png": 786,
	"./logo-facebook.png": 787,
	"./logo-google.png": 788,
	"./logo-lydian-black.png": 789,
	"./logo-lydian-black.svg": 790,
	"./logo-lydian-white.svg": 791,
	"./logo-regalx-white.png": 792,
	"./logo-regalx.png": 793,
	"./logo-skyground-black.svg": 794,
	"./logo-skyground-white.svg": 795,
	"./logo-swissmarkets-white.svg": 796,
	"./logo-swissmarkets.png": 797,
	"./logo-swissmarkets.svg": 798,
	"./logo-tauromarkets-black.png": 799,
	"./logo-tauromarkets-white.png": 800,
	"./logo-tauromarkets-white2.png": 801,
	"./logo-tauromarkets-white2.svg": 802,
	"./logo-valutamarkets.png": 803,
	"./maestro.png": 804,
	"./mastercard.png": 805,
	"./mastercard_logo_icon.svg": 806,
	"./mercedesCup-dark.svg": 807,
	"./mercedesCup-light.svg": 808,
	"./nationalIdBR.png": 809,
	"./nationalIdES.jpg": 810,
	"./nationalIdIT.jpg": 811,
	"./nationalIdZA.png": 812,
	"./no-trades-dark.png": 813,
	"./no-trades-light.png": 814,
	"./no-trading-signals-dark.png": 815,
	"./nok.png": 816,
	"./notifications-empty-dark.png": 817,
	"./notifications-empty-light.png": 818,
	"./onlineBanking.svg": 819,
	"./onlineDeposit.svg": 820,
	"./page-not-found-dark.svg": 443,
	"./page-not-found-light.svg": 444,
	"./payment-failure-dark.png": 821,
	"./payment-failure-light.png": 822,
	"./payment-pending-dark.png": 823,
	"./payment-pending-light.png": 824,
	"./payment-success-dark.png": 825,
	"./payment-success-light.png": 826,
	"./payments-history-empty-dark.png": 827,
	"./payments-history-empty-light.png": 828,
	"./phone_verification.png": 829,
	"./place1-leadership.png": 830,
	"./place2-leadership.png": 831,
	"./place3-leadership.png": 832,
	"./pln.png": 833,
	"./pof-bankStatement.png": 834,
	"./pof-bankStatementPOF.png": 835,
	"./pof-card-back.png": 836,
	"./pof-card.png": 837,
	"./pof-cardStatement.png": 838,
	"./pof-other.png": 839,
	"./pof-proofOfResidence.png": 840,
	"./pof-swiftCopyPaymentAdvice.png": 841,
	"./pof-virtualCard.png": 842,
	"./poi-document.png": 843,
	"./poi-drivingLicense-back.png": 844,
	"./poi-drivingLicense.png": 845,
	"./poi-id-back.png": 846,
	"./poi-id.png": 847,
	"./poi-passport.png": 848,
	"./por-bankStatementPOR.png": 849,
	"./por-document.png": 850,
	"./por-proofOfResidence.png": 851,
	"./por-utilityBill.png": 852,
	"./priority@2x.svg": 853,
	"./referAndEarn.png": 854,
	"./regalxDemo_downloadMT4.png": 855,
	"./regalxReal01_downloadMT4.png": 856,
	"./regalxReal02_downloadMT4.png": 857,
	"./regalxReal03_downloadMT4.png": 858,
	"./regalxReal04_downloadMT4.png": 859,
	"./regalxReal05_downloadMT4.png": 860,
	"./register-referral-light.png": 861,
	"./sek.png": 862,
	"./sign-up.png": 863,
	"./spaceship.png": 864,
	"./spreads@2x.svg": 865,
	"./support@2x.svg": 866,
	"./swissmarketsDemo_downloadMT4.png": 867,
	"./swissmarketsReal02_downloadMT4.png": 868,
	"./swissmarketsReal_downloadMT4.png": 869,
	"./tauroDemo01DownloadMT4.jpg": 870,
	"./tauroReal01DownloadMT4.jpg": 871,
	"./technicalIndicator-ebook.png": 872,
	"./technicalIndicatorItem.svg": 873,
	"./telegram-dark.png": 874,
	"./telegram.png": 875,
	"./trading-alerts-tradingAlerts-dark.png": 876,
	"./trading-alerts-tradingAlerts-light.png": 877,
	"./tradingPsychology-ebook.png": 878,
	"./tradingPsychologyItem.svg": 879,
	"./transfer-external.svg": 880,
	"./transfer-internal.svg": 881,
	"./transfer-spoa.svg": 882,
	"./upload-bankStatement-error.png": 883,
	"./upload-bankStatement-success.png": 884,
	"./upload-bankStatement.png": 885,
	"./upload-document-dark.png": 886,
	"./upload-document-light.png": 887,
	"./upload-generic-error.png": 888,
	"./upload-generic-success.png": 889,
	"./upload-generic.png": 890,
	"./upload-pof-back-card-error.png": 891,
	"./upload-pof-back-card-success.png": 892,
	"./upload-pof-back-card.png": 893,
	"./upload-pof-front-card-error.png": 894,
	"./upload-pof-front-card-success.png": 895,
	"./upload-pof-front-card.png": 896,
	"./upload-poi-back-drivingLicense-error.png": 897,
	"./upload-poi-back-drivingLicense-success.png": 898,
	"./upload-poi-back-drivingLicense.png": 899,
	"./upload-poi-back-error.png": 900,
	"./upload-poi-back-success.png": 901,
	"./upload-poi-back.png": 902,
	"./upload-poi-front-drivingLicense-error.png": 903,
	"./upload-poi-front-drivingLicense-success.png": 904,
	"./upload-poi-front-drivingLicense.png": 905,
	"./upload-poi-front-error.png": 906,
	"./upload-poi-front-success.png": 907,
	"./upload-poi-front.png": 908,
	"./upload-por-front-error.png": 909,
	"./upload-por-front-proofOfResidence-error.png": 910,
	"./upload-por-front-proofOfResidence-success.png": 911,
	"./upload-por-front-proofOfResidence.png": 912,
	"./upload-por-front-success.png": 913,
	"./upload-por-front-utilityBill-error.png": 914,
	"./upload-por-front-utilityBill-success.png": 915,
	"./upload-por-front-utilityBill.png": 916,
	"./upload-por-front.png": 917,
	"./usd.png": 918,
	"./visa.png": 919,
	"./visa_logo_icon.svg": 920,
	"./vps-enter-credentials.png": 921,
	"./vps-remote-desktop-windows.png": 922,
	"./vps-remote-desktop.png": 923,
	"./waiting-list-skip-dark.png": 924,
	"./waiting-list-skip.png": 925,
	"./windows-brands.svg": 926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1314;